import { render, staticRenderFns } from "./ChatSettingsModel.vue?vue&type=template&id=53470545&"
import script from "./ChatSettingsModel.vue?vue&type=script&lang=js&"
export * from "./ChatSettingsModel.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettingsModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports